import React from "react";

import FormField from "../form-field/FormField";

interface EditDescriptionProps {
  description: string | null;
  labelKey?: string;
  placeholderKey?: string;
}

export default function EditDescription(props: EditDescriptionProps) {
  return (
    <FormField
      id="description"
      className="textarea"
      labelKey={props.labelKey || "general.description"}
      fieldName="description"
      fieldValue={props.description || ""}
      component="textarea"
      placeholderKey={props.placeholderKey || "EditDescription.label"}
      maxLength={1000}
    />
  );
}
